'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (equalTo) {
  return function (value, parentVm) {
    if (value === null || value === undefined || value === '') {
      return true;
    }

    var compareTo = typeof equalTo === 'function' ? equalTo.call(this, parentVm) : parentVm[equalTo];
    return value === compareTo;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/sameAs.js
// module id = ./node_modules/vuelidate/lib/validators/sameAs.js
// module chunks = 0